import { RESET_TUTORIALS, SET_TUTORIALS_COMPLETED } from 'phoenix2/state/tutorial/actions';

/**
 * Reducer for the 4 stages of the Fast Track Quiz tutorial that appears on the task items view,
 * explaining what the different statuses of task items are
 */

export const FTQ_TASK_ITEM_TUTORIAL_KEY = 'ftqTaskItemTutorial';
export const FTQ_TASK_ITEM_FAST_TRACKED_TUTORIAL_KEY = 'ftqTaskItemFastTrackedTutorial';
export const FTQ_TASK_ITEM_CORRECT_TUTORIAL_KEY = 'ftqTaskItemCorrectTutorial';
export const FTQ_TASK_ITEM_INCORRECT_TUTORIAL_KEY = 'ftqTaskItemIncorrectTutorial';
export const FTQ_TASK_ITEM_TO_DO_TUTORIAL_KEY = 'ftqTaskItemToDoTutorial';

export type IFTQTaskItemTutorialKey =
    | 'ftqTaskItemFastTrackedTutorial'
    | 'ftqTaskItemCorrectTutorial'
    | 'ftqTaskItemIncorrectTutorial'
    | 'ftqTaskItemToDoTutorial';

export interface IFTQTaskItemTutorialState {
    // Whether the student has completed the tutorial.
    completedFastTracked: boolean;
    completedCorrect: boolean;
    completedIncorrect: boolean;
    completedToDo: boolean;
}

const INITIAL_STATE: IFTQTaskItemTutorialState = {
    completedFastTracked: false,
    completedCorrect: false,
    completedIncorrect: false,
    completedToDo: false,
};

export function FTQTaskItemTutorialReducer(
    state = INITIAL_STATE,
    action: any,
): IFTQTaskItemTutorialState {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;
        case SET_TUTORIALS_COMPLETED:
            const completion = { ...state };
            if (action.tutorialIds.includes(FTQ_TASK_ITEM_FAST_TRACKED_TUTORIAL_KEY)) {
                completion.completedFastTracked = true;
            }
            if (action.tutorialIds.includes(FTQ_TASK_ITEM_CORRECT_TUTORIAL_KEY)) {
                completion.completedCorrect = true;
            }
            if (action.tutorialIds.includes(FTQ_TASK_ITEM_INCORRECT_TUTORIAL_KEY)) {
                completion.completedIncorrect = true;
            }
            if (action.tutorialIds.includes(FTQ_TASK_ITEM_TO_DO_TUTORIAL_KEY)) {
                completion.completedToDo = true;
            }
            return completion;
            break;
    }
    return state;
}

export const allFTQTaskItemTutorialsComplete = (state: IFTQTaskItemTutorialState) =>
    state.completedFastTracked &&
    state.completedCorrect &&
    state.completedIncorrect &&
    state.completedToDo;
